import {
  SET_TRATAMIENTO,
  SET_NOMBRE_AUDI_NUEVO,
  SET_APELLIDO_MATERNO_AUDI_NUEVO,
  SET_APELIIDO_PATERNO_AUDI_NUEVO,
  SET_ESTADO_AUDI_NUEVO,
  SET_CIUDAD_AUDI_NUEVO,
  SET_ID_CONCESIONARIO_AUDI_NUEVO,
  SET_CONCESIONARIO_AUDI_NUEVO,
  SET_TELEFONO_AUDI_NUEVO,
  SET_MOVIL_AUDI_NUEVO,
  SET_CORREO_AUDI_NUEVO,
  SET_COMENTARIOS_AUDI_NUEVO,
  SET_SEXO,
  SET_AVISO_PRIVACIDAD_AUDI_NUEVO,
  SET_TERMINOS_Y_CONDICIONES_AUDI_NUEVO,
  SET_TRANSFERENCIA_DE_DATOS_AUDI_NUEVO,
  SET_CONTACO_MARKETING_AUDI_NUEVO,
  SET_VEIHICULO_AUDI_NUEVO,
  SET_TIPO_CITA_AUDI_NUEVO,
  RESET_STATE_AUDI_NUEVO,
} from "../types";

const initialState = {
  fuenteSitioWeb: "Sitio Web Audi",
  marca: "Audi",
  tipoRegistro: "Importador",
  fuenteSecundaria: "Medios Digitales Importador",
  tercerNivel: "",
  llaveOrigen: "AUSW",
  tratamiento: "Sr",
  nombre: "",
  apellidoMaterno: "",
  apellidoPaterno: "",
  telefono: "",
  celular: "",
  email: "",
  ciudad: "",
  provincia: "",
  concesionariaPreferida: "",
  vehiculoActual: "",
  descripcion: "",
  permisoTransferenciaDatos: false,
  permisoContactoMarketing: false,
  urlWeb: "https://www.audi.com.mx/es/",
  tipoCita: "Quiero comprar un Audi nuevo",
  fechaNacimiento: "",
  numeroConcesionaria: "",
  horarioPreferente: "",
  fechaPreferente: "",
  vehiculoInteres: "",
  urlPrivacidad: "https://www.audi.com.mx/es/tools/navigation/layer/legal/",
  sexo: "Masculino",
  status: "Nuevo",
  fbCampaignID: "",
  //datos extra para el formulario
  avisoPrivacidad: false,
  terminosCondiciones: false,
  nombreDelVehiculo: "",
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case SET_TRATAMIENTO:
      return {
        ...state,
        tratamiento: action.payload,
      };
    case SET_NOMBRE_AUDI_NUEVO:
      return {
        ...state,
        nombre: action.payload,
      };
    case SET_APELLIDO_MATERNO_AUDI_NUEVO:
      return {
        ...state,
        apellidoMaterno: action.payload,
      };
    case SET_APELIIDO_PATERNO_AUDI_NUEVO:
      return {
        ...state,
        apellidoPaterno: action.payload,
      };
    case SET_ESTADO_AUDI_NUEVO:
      return {
        ...state,
        provincia: action.payload,
      };
    case SET_CIUDAD_AUDI_NUEVO:
      return {
        ...state,
        ciudad: action.payload,
      };
    case SET_ID_CONCESIONARIO_AUDI_NUEVO:
      return {
        ...state,
        numeroConcesionaria: action.payload,
      };
    case SET_CONCESIONARIO_AUDI_NUEVO:
      return {
        ...state,
        concesionariaPreferida: action.payload,
      };
    case SET_TELEFONO_AUDI_NUEVO:
      return {
        ...state,
        telefono: action.payload,
      };
    case SET_MOVIL_AUDI_NUEVO:
      return {
        ...state,
        celular: action.payload,
      };
    case SET_CORREO_AUDI_NUEVO:
      return {
        ...state,
        email: action.payload,
      };
    case SET_COMENTARIOS_AUDI_NUEVO:
      return {
        ...state,
        descripcion: action.payload,
      };
    case SET_SEXO:
      return {
        ...state,
        sexo: action.payload,
      };
    case SET_AVISO_PRIVACIDAD_AUDI_NUEVO:
      return {
        ...state,
        avisoPrivacidad: action.payload,
      };
    case SET_TERMINOS_Y_CONDICIONES_AUDI_NUEVO:
      return {
        ...state,
        terminosCondiciones: action.payload,
      };
    case SET_TRANSFERENCIA_DE_DATOS_AUDI_NUEVO:
      return {
        ...state,
        permisoTransferenciaDatos: action.payload,
      };
    case SET_CONTACO_MARKETING_AUDI_NUEVO:
      return {
        ...state,
        permisoContactoMarketing: action.payload,
      };
    case SET_VEIHICULO_AUDI_NUEVO:
      return {
        ...state,
        vehiculoInteres: action.payload,
      };
    case SET_TIPO_CITA_AUDI_NUEVO:
      return {
        ...state,
        tipoCita: action.payload,
      };
    case RESET_STATE_AUDI_NUEVO:
      return initialState;
    default:
      return state;
  }
}
